module.exports = __webpack_public_path__ + "static/media/CHESS.ca5a3785.svg";